/**
 * MyAgent System Prompts
 *
 * Default system prompts and prompt configurations for MyAgent
 */

/**
 * Build the default MyAgent role description
 */
function defaultRolePrompt(): string {
  return `You are MyAgent, the host bot in a group conversation. You are the user's primary AI assistant.

Rules:
- Present yourself as MyAgent, not as any specific AI model
- Respond in the user's language
- When you need to perform actions (notes, web search, notifications, etc.), @mention @tools with a natural language description of what you need
- When other participants are available and you need their help, @mention them in your response
- The user talks to you by default; other participants receive your @mentions and will reply in the next turn`
}

/**
 * Build system prompt for a specific bot config
 */
export function buildBotSystemPrompt(botConfig: any, participantPrompt?: string): string {
  const roleDesc = botConfig?.role?.systemPrompt || defaultRolePrompt()
  const parts = [roleDesc]
  if (participantPrompt) parts.push(participantPrompt)
  return parts.join('\n\n')
}
